import AppPagination from './AppPagination.vue'

export default AppPagination
